import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../contexts/TranslationContext';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="bg-gray-800 text-white safe-area-bottom">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8">
                {/* Mobile-first grid layout */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-3">
                    {/* Company Info - Full width on mobile */}
                    <div className="col-span-2 md:col-span-2">
                        <div className="flex items-center mb-2 sm:mb-1">
                            <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center mr-2">
                                <img
                                    src="/favicon.svg"
                                    alt="Ablex Logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <span className="text-base font-bold text-white">
                                Ablex
                            </span>
                        </div>
                        <div className="space-y-1.5 sm:space-y-0.5">
                            {/* Email - Clickable on mobile */}
                            <a 
                                href="mailto:alex@buergstaller.it"
                                className="flex items-center text-gray-300 text-xs sm:text-xs hover:text-white transition-colors touch-feedback py-1"
                            >
                                <div className="w-4 h-4 flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <span className="truncate">alex@buergstaller.it</span>
                            </a>
                            {/* Address - Clickable to maps */}
                            <a 
                                href="https://maps.google.com/?q=Sigmundweg+2,+39030+Kiens"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center text-gray-300 text-xs sm:text-xs hover:text-white transition-colors touch-feedback py-1"
                            >
                                <div className="w-4 h-4 flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0">
                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <span>Sigmundweg 2, 39030 Kiens (BZ)</span>
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-sm sm:text-base font-bold text-white mb-2 sm:mb-2">{t('footer.navigation')}</h3>
                        <ul className="space-y-1 sm:space-y-0.5">
                            <li>
                                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-200 block py-1.5 sm:py-0.5 text-xs touch-target min-h-[36px] sm:min-h-0 flex items-center">
                                    {t('header.home')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-200 block py-1.5 sm:py-0.5 text-xs touch-target min-h-[36px] sm:min-h-0 flex items-center">
                                    {t('header.contact')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h3 className="text-sm sm:text-base font-bold text-white mb-2 sm:mb-2">{t('footer.legal')}</h3>
                        <ul className="space-y-1 sm:space-y-0.5">
                            <li>
                                <Link to="/impressum" className="text-gray-300 hover:text-white transition-colors duration-200 block py-1.5 sm:py-0.5 text-xs touch-target min-h-[36px] sm:min-h-0 flex items-center">
                                    {t('footer.impressum')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/datenschutz" className="text-gray-300 hover:text-white transition-colors duration-200 block py-1.5 sm:py-0.5 text-xs touch-target min-h-[36px] sm:min-h-0 flex items-center">
                                    {t('footer.datenschutz')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Copyright section - Mobile optimized */}
                <div className="border-t border-gray-700 mt-4 sm:mt-3 pt-4 sm:pt-3">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-0">
                        <p className="text-gray-400 text-xs text-center sm:text-left">
                            {t('footer.copyright')}
                        </p>
                        <div className="flex items-center">
                            <span className="text-gray-400 text-xs">{t('footer.slogan')}</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
